/* lua.js generated code 0.3.0 */

require("clover/utils/MemClass")
var uuid = require("hecore/uuid")
var debugDataRef = false
function createPropertyMethod(t, name) {
    if (typeof t !== 'function' || typeof name !== "string") {
        return 
    }
    var methodName = name.charAt(0).toUpperCase() + name.slice(1)
    var getterName = "get" + methodName    
    t.prototype[getterName] = function () {
        return this[name]
    }
    var setterName = "set" + methodName
    t.prototype[setterName] = function (value) {
        this[name] = value 
    }
}
function createPropertyMethods(cls, properties) {
    for (let i = 0; i < properties.length; i++) {
        createPropertyMethod(cls, properties[i])
    }
}
// DataRef ---------------------------------------------------------
DataRef = xClass("DataRef")
DataRef.prototype.dispose = function () { }
DataRef.prototype.fromLua = function (src) {
    var self = this
    if (!src) {
        cc.log("  [WARNING] lua data is nil")
        return 
    }
    for (var k in src) {
        var v = src[k]
        if (type(v) !== "function") {
            self[k] = v
        }
        if (debugDataRef) {
            cc.log(k, v)
        }
    }
}
DataRef.prototype.encode = function () {
    var self = this
    var dst = table()
    for (var k in self) {
        var v = self[k]
        if (k !== "class" && v != null && type(v) !== "function") {
            dst[k] = v
        }
    }
    return dst
}
DataRef.prototype.decode = function (src) {
    var self = this
    self.fromLua(src)
}
function parseItemList(src) {
    if (!src) {
        return table()
    }
    assert(type(src) === "string")
    var result = table()
    var items = src.split(",")
    if (items && $len(items) > 0) {
        for (var i = 1, v = items[1]; v; i++, v = items[i]) {
            result[i] = tonumber(v)
        }
    }
    if (debugDataRef) {
        cc.log("parseItemList", $len(result))
    }
    return result
}
// ProfileRef ---------------------------------------------------------
ProfileRef = xClass("ProfileRef", DataRef)
ProfileRef.prototype.ctor = function () {
    var self = this
    self.uid = 0
    self.name = getText("clover.default.name")
    self.headUrl = "http://sff.happyelements.com/cdn/app/1001/avatar/7.png"
    self.constellation = 0
    self.age = 0
    self.gender = 0
    self.snsMap = table()
    self.secret = false
    self.fileId = ""
    self.fullStarIslandNum = 0
}
ProfileRef.prototype.getUid = function () {
    var self = this
    return self.uid
}
ProfileRef.prototype.setUid = function (uid) {
    var self = this
    self.uid = uid
}
ProfileRef.prototype.getName = function () {
    var self = this
    // WARN: maybe multi result
    return he.HeDisplayUtil.urlDecode(self.name)
}
ProfileRef.prototype.setName = function (name) {
    var self = this
    self.name = self.filterName(tostring(name || ""))
}
ProfileRef.prototype.getHeadUrl = function () {
    var self = this
    return self.headUrl
}
ProfileRef.prototype.setHeadUrl = function (headUrl) {
    var self = this
    self.headUrl = self.filterHeadUrl(headUrl)
}
ProfileRef.prototype.fromLua = function (data) {
    var self = this
    if (!data) {
        return self
    }
    self.uid = tonumber(data.uid || 0)
    self.name = self.filterName(he.HeDisplayUtil.urlDecode(tostring(data.name ||"")))
    self.headUrl = self.filterHeadUrl(data.headUrl)
    self.snsMap = data.snsMap || table()
    self.secret = data.secret === true
    self.fileId = data.fileId || ""
    self.fullStarIslandNum = data.fullStarIslandNum
    return self
}
ProfileRef.prototype.getSnsHeadUrl = function () {
    var __VA_ARG = $slice(arguments, 0)
    var self = this
    var platformName = PlatformConfig.getPlatformAuthName(Localhost.getLastLoginOauthID())
    if (platformName === "phone") {
        return null
    }
    for (var k in self.snsMap) {
        var v = self.snsMap[k]
        if (v.snsPlatform === platformName) {
            if (v.headUrl == null || v.headUrl === "") {
                return null
            } else {
                // WARN: maybe multi result
                return self.filterHeadUrl(v.headUrl)
            }
        }
    }
    return null
}
// 1、如果名字为空（空字符串）则改为“消消乐玩家
// 2、去掉过长的名字 16个字符为上限
// 3、从名字中去掉不合法的字符：\r \n
ProfileRef.prototype.filterName = function (name) {
    // FIXME: filter name
    if(!name || name === ""){
        return getText("clover.default.name")
    }else {
        name.replace("\r","")
        name.replace("\n","")
        if(name.length > 16){
            return name.substring(0,16)
        }else{
            return name
        }
    }
    // var self = this
    // if (!name || string.len(tostring(name)) <= 0) {
    //     // WARN: maybe multi result
    //     return getText("clover.default.name")
    // }
    // var [charTab, count] = [table(), 0]
    // var $st33 = string.gfind(tostring(name), "[%z\\1-\\127\\194-\\244][\\128-\\191]*")
    // while(1) {
    //     var t = $st33[0]($st33[1], $st33[2])
    //     var uchar = t[0]
    //     if (uchar == null) break
    //     $st33[2] = uchar
    //     if (count >= 16) {
    //         break
    //     }
    //     if (uchar !== "\r" && uchar !== "\n") {
    //         table.insert(charTab, uchar)
    //         count = count + 1
    //     }
    // }
    // // WARN: maybe multi result
    // return table.concat(charTab)
}
// 1、如果URL为空或空字符 则随机取一个默认头
// 2、如果URL为“ani://”开 则去掉此开头作为头像URL
ProfileRef.prototype.filterHeadUrl = function (headUrl) {
    var self = this
    if (type(headUrl) !== "string" || string.len(tostring(headUrl)) <= 0) {
        // WARN: maybe multi result
        return tostring(Math.mod(tonumber(self.uid), 10))
    }
    if (string.starts(tostring(headUrl), "ani://")) {
        // WARN: maybe multi result
        return string.sub(tostring(headUrl), 7)
    } 
    return headUrl
}
// 该函数已过时
ProfileRef.prototype.haveName = function () {
    var self = this
    if (self.name && self.name !== "") {
        return true
    } else {
        return false
    }
}
// 该函数已过时
ProfileRef.prototype.setDisplayName = function (name) {
    var self = this
    self.setName(name)
}
// 该函数已过时
ProfileRef.prototype.getDisplayName = function () {
    var self = this
    if (self.haveName()) {
        // WARN: maybe multi result
        return he.HeDisplayUtil.urlDecode(self.name)
    } else {
        return "ID:" + tostring(self.uid)
    }
}
ProfileRef.prototype.getSnsInfo = function (authorizeType) {
    var self = this
    if (PlatformAuthDetail[authorizeType]) {
        for (let k in self.snsMap) {
            let v = self.snsMap[k]
            if ($null(v)) continue
            if (v.snsPlatform === PlatformAuthDetail[authorizeType].name) {
                return v
            }
        }
    }
    return null
}
ProfileRef.prototype.setSnsInfo = function (authorizeType, snsName, name, headUrl) {
    var self = this
    if (PlatformAuthDetail[authorizeType]) {
        var snsInfo = self.getSnsInfo(authorizeType)
        if (!snsInfo) {
            snsInfo = table([1, "snsPlatform", PlatformAuthDetail[authorizeType].name])
            table.insert(self.snsMap, snsInfo)
        }
        if (snsName) {
            snsInfo.snsName = he.HeDisplayUtil.urlEncode(snsName)
        }
        if (name) {
            snsInfo.name = he.HeDisplayUtil.urlEncode(name)
        }
        if (headUrl) {
            snsInfo.headUrl = headUrl
        }
    }
}
ProfileRef.prototype.getSnsUsername = function (authorizeType) {
    var self = this
    if (PlatformAuthDetail[authorizeType]) {
        var snsInfo = self.getSnsInfo(authorizeType)
        if (snsInfo) {
            // WARN: maybe multi result
            return he.HeDisplayUtil.urlDecode(snsInfo.snsName || "")
        } else {
            return null
        }
    } else {
        return null
    }
}
// UserRef ---------------------------------------------------------
UserRef = xClass("UserRef", DataRef)
UserRef.prototype.ctor = function () {
    var self = this
    self.uid = 0
    self.friendNum = 0
    self.updateTime = 0
    self.topLevelId = 0
    self.coin = 0
    self.orangeStar = 0
    self.blueStar = 0
    self.yellowStar = 0
    self.cash = 0
    self.energy = 0
    self.passTopLevel = 0
    self.branchLevelCount = 0
    self.haveLiked = true
    self.beLiked = 0
    self.starUpdateTime = 0
    self.headFrameId = 0
    self.areaCode = 0
}
createPropertyMethods(UserRef, [
    "friendNum", "updateTime", "topLevelId", "coin", "cash", 
    "orangeStar", "blueStar", "yellowStar", "energy", "passTopLevel", 
    "haveLiked", "beLiked", "starUpdateTime"
])
UserRef.prototype.fromLua = function (src) {
    var self = this
    if (!src) {
        cc.log("  [WARNING] lua data is nil at UserRef:fromLua")
        return 
    }
    for (let k in src) {
        let v = src[k]
        if ($null(v)) continue
        if (type(v) !== "function") {
            self[k] = v
        }
        if (debugDataRef) {
            cc.log(k, v)
        }
    }
    self.updateTime = tonumber(src.updateTime) || Localhost.time()
    self.starUpdateTime = tonumber(src.starUpdateTime) || 0
    return self
}
UserRef.prototype.getTotalStar = function () {
    var self = this
    return self.getYellowStar() + self.getOrangeStar() + self.getBlueStar()
}

// UserShowRef ---------------------------------------------------------
UserShowRef = xClass("UserShowRef", DataRef)
UserShowRef.prototype.ctor = function () {
    var self = this
    self.headList = []
    self.frameList = []
    self.cardList = []
    self.labelList = []
    self.nameEffectList = []
}
createPropertyMethods(UserShowRef, [
    "headList", "frameList", "cardList", "labelList", "nameEffectList"
])
UserShowRef.prototype.fromLua = function (src) {
    var self = this
    if (!src) {
        cc.log("  [WARNING] lua data is nil at UserShowRef:fromLua")
        return 
    }
    for (let k in src) {
        let v = src[k]
        if ($null(v)) continue
        if (type(v) !== "function") {
            if (k == "headList" || k == "frameList" || k == "cardList" || k == "labelList" || k == "nameEffectList"){
                self[k] = $tableToArray(v)
            }else{
                self[k] = v
            }
        }
        if (debugDataRef) {
            cc.log(k, v)
        }
    }
    // self.updateTime = tonumber(src.updateTime) || Localhost.time()
    // self.starUpdateTime = tonumber(src.starUpdateTime) || 0
    return self
}
UserShowRef.prototype.getNameCardId = function () {
    var self = this
    // for (let item of self.cardList){
    // // table.each(self.cardList, function(){

    // // })
    let now = Localhost.time()
    let list = self.cardList
    // for (let i = 1; i <= $len(list); i++){
    //     if (list[i].use == 1 && (list[i].expireTime <= 0 || now < list[i].expireTime ))
    //         return list[i].id
    // }
    for (let i = 0; i < list.length; i++) {
        if (list[i].use == 1 && (list[i].expireTime <= 0 || now < list[i].expireTime ))
            return list[i].id
    }
    return null
}
UserShowRef.prototype.getNameLabelId = function () {
    var self = this
    let now = Localhost.time()
    let list = self.labelList
    // for (let i = 1; i <= $len(list); i++){
    //     if (list[i].use == 1 && (list[i].expireTime <= 0 || now < list[i].expireTime ))
    //         return list[i].id
    // }
    for (let i = 0; i < list.length; i++) {
        if (list[i].use == 1 && (list[i].expireTime <= 0 || now < list[i].expireTime ))
            return list[i].id
    }
    return null
}

UserShowRef.prototype.getNameLabelIdWithExpireTime = function () {
    var self = this
    let now = Localhost.time()
    let list = self.labelList
    // for (let i = 1; i <= $len(list); i++){
    //     if (list[i].use == 1 && (list[i].expireTime <= 0 || now < list[i].expireTime ))
    //         return [list[i].id, list[i].expireTime]
    // }
    for (let i = 0; i < list.length; i++) {
        if (list[i].use == 1 && (list[i].expireTime <= 0 || now < list[i].expireTime ))
            return [list[i].id, list[i].expireTime]
    }
    return [0, 0]
}
UserShowRef.prototype.addAndUseWithDressId = function(list, id, expireTime){
    /**
     * 需要修改
     */
    //判断过期时间
    // let now = Localhost.time()
    // if (now >= expireTime && expireTime != -1) {
    //     console.log("UserShowRef addAndUseWithDressId false",list, id, expireTime )
    //     return
    // }

    let hasDress = false
    for (let i = 0; i < list.length; i++) {
        let item = list[i]
        if (item.id == id){ //有这个id 设置使用状态和时间
            hasDress = true
            item.use = 1
            item.expireTime = expireTime || 0
        }else {
            item.use = 0
        }  
    }

    // let hasDress = false
    // table.each(list, function(item){
    //     if (item.id == id){ //有这个id 设置使用状态和时间
    //         hasDress = true
    //         item.use = 1
    //         item.expireTime = expireTime || -1
    //     }else {
    //         item.use = 0
    //     }   
    // })

    //如没有这个id，增加
    if (!hasDress){
        list.push({
            id : id,
            use : 1,
            expireTime : expireTime || 0,
            obtainTime : Localhost.time()
        })
        // table.insert(list, {
        //     id : id,
        //     use : 1,
        //     expireTime : expireTime || -1,
        // })
    }
}
// UserShowRef.prototype.addAndUseNameCardId = function(){

// }
// UserShowRef.prototype.useNameCardId = function (id, expireTime) {
//     var self = this
//     for (let item of self.cardList){
//         if (item.id == id){
//             item.use = 1
//             item.expireTime = expireTime || -1
//         }else {
//             item.use = 0
//         }
           
//     }
// }
// UserShowRef.prototype.useNameLabelId = function (id, expireTime) {
//     var self = this
//     for (let item of self.labelList){
//         if (item.id == id){
//             item.use = 1
//             item.expireTime = expireTime || -1
//         }else {
//             item.use = 0
//         }
//     }
// }

// UserExtendRef ---------------------------------------------------------
UserExtendRef = xClass("UserExtendRef", DataRef)
UserExtendRef.prototype.ctor = function () {
    var self = this
    self.setFruitTreeLevel(0)
    self.setStarReward(0)
    self.setNewUserReward(0)
    self.setShortcutReward(0)
    self.setShortcutEnterReward(0)
    self.setIsFristPay(1)
    self.setEnergyPlusEffectTime(0)
    self.setNotConsumeEnergyBuff(0)
    self.setPrePropNoLimitTime(0)
    self.qqVipNewComeReward = false
    self.appOnQQPanel = false
    self.appOnQQPanelRewardMark = 0
    self.ladyBugStart = 0
    self.goldTicket = 0
    self.energyPlusId = 0
    self.energyPlusPermanentId = 0
    self.activityMark = 0
    self.scoreGameReward = 0
    self.tutorialStep = 0
    self.playStep = 0
    self.topLevelFailCount = 0
    self.locationState = 0
    self.inviteCountFlag = 0
    self.branchLevelCount = 0
    self.inviteFriendCount = 0
    self.payUser = false
    self.lastPayTime = 0
    self.invitePopup = 0
    self.inviter = 0
    self.identifyNum = null
    self.consumeSum = 0
    self.hasFetchLeadRewards = false
    self.ipRegionLimit = {}
    self.energyMaxCount = 30
    self.topLevelStreak = 0
    self.lastShowSubscribeWhatsNewTs = 0
    self.startLevelReplay = null


}
createPropertyMethods(UserExtendRef, [
    "isFristPay", "fruitTreeLevel", "starReward", "newUserReward", "prePropNoLimitTime",
    "shortcutReward", "shortcutEnterReward", "prePropNoLimitTime", "energyPlusEffectTime", "energyMaxCount", "startLevelReplay", "notConsumeEnergyBuff",
    "topLevelStreak"
])
UserExtendRef.prototype.isStarRewardReceived = function (rewardLevel) {
    var __VA_ARG = $slice(arguments, 1)
    var self = this
    assert(type(rewardLevel) === "number")
    assert($len(table([2, __VA_ARG])) === 0)
    var mask = bit.lshift(1, rewardLevel)
    var result = bit.band(self.getStarReward(), mask)
    return result > 0
}
UserExtendRef.prototype.setRewardLevelReceived = function (rewardLevel) {
    var __VA_ARG = $slice(arguments, 1)
    var self = this
    assert(type(rewardLevel) === "number")
    assert($len(table([2, __VA_ARG])) === 0)
    if (self.isStarRewardReceived(rewardLevel)) {
        assert(false)
    }
    var mask = bit.lshift(1, rewardLevel)
    self.setStarReward(bit.bor(self.getStarReward(), mask))
}
UserExtendRef.prototype.getFirstNotReceivedRewardLevel = function (rewardLevel) {
    var __VA_ARG = $slice(arguments, 1)
    var self = this
    assert($len(table([2, __VA_ARG])) === 0)
    var $limit131 = rewardLevel
    for (var index = 1; index <= $limit131; index += 1) {
        if (!self.isStarRewardReceived(index)) {
            return index
        }
    }
    return false
}
UserExtendRef.prototype.hasEnteredInviteCode = function () {
    var self = this
    if (!self.flag) {
        return false
    }
    return 1 === bit.band(self.flag, 0x01)
}
UserExtendRef.prototype.hasFirstThirdPay = function () {
    var self = this
    if (!self.flag) {
        return true
    }
    return 1 === bit.band(bit.rshift(self.flag, 8), 0x01)
}
UserExtendRef.prototype.setEnteredInviteCode = function (isSet) {
    var self = this
    if (!self.flag) {
        return 
    }
    if (isSet) {
        self.flag = bit.bor(self.flag, 0x01)
    } else if (1 === bit.band(self.flag, 0x01)) {
        self.flag = self.flag - 1
    }
}
UserExtendRef.prototype.allowChangePhoneBinding = function () {
    var self = this
    if (!self.flag) {
        return true
    }
    return !self.isFlagBitSet(8)
}
UserExtendRef.prototype.isIosGuideRewardReceived = function () {
    var self = this
    if (!self.flag) {
        return true
    } // 未联网或没有flag
    // WARN: maybe multi result
    return self.isFlagBitSet(10)
}
UserExtendRef.prototype.setIosGuideRewardReceived = function (value) {
    var self = this
    if (!self.flag) {
        return 
    }
    self.setFlagBit(10, (value === true))
}
UserExtendRef.prototype.isFlagBitSet = function (bitIndex) {
    var self = this
    self.flag = self.flag || 0
    if (bitIndex < 1) {
        bitIndex = 1
    }
    var mask = Math.pow(2, bitIndex - 1)
    return mask === bit.band(self.flag, mask)
}
UserExtendRef.prototype.setFlagBit = function (bitIndex, setToTrue) {
    var self = this
    self.flag = self.flag || 0
    if (bitIndex < 1) {
        bitIndex = 1
    }
    var mask = Math.pow(2, bitIndex - 1)
    if (setToTrue === true || setToTrue === 1) {
        self.flag = bit.bor(self.flag, mask)
    } else if (mask === bit.band(self.flag, mask)) {
        self.flag = self.flag - mask
    }
    return self.flag
}
UserExtendRef.prototype.payUser = function () {
    var self = this
    return self.payUser
}
UserExtendRef.prototype.setPayUser = function (value) {
    let self = this
    if (value == null) {
        value = true
    }
    self.payUser = value
}
UserExtendRef.prototype.getLastPayTime = function () {
    var self = this
    return self.lastPayTime || 0
}
UserExtendRef.prototype.setLastPayTime = function (time) {
    var self = this
    if (type(time) === "number") {
        self.lastPayTime = time
    }
}
// 在开始游戏时就记为失败，成功过关后清
UserExtendRef.prototype.incrTopLevelFailCount = function (count) {
    var self = this
    count = count || 1
    self.topLevelFailCount = self.topLevelFailCount + count
}
UserExtendRef.prototype.resetTopLevelFailCount = function () {
    var self = this
    self.topLevelFailCount = 0
}
UserExtendRef.prototype.setLocationState = function (state) {
    var self = this
    self.locationState = state
}
UserExtendRef.prototype.fromLua = function (src) {
    var self = this
    if (!src) {
        cc.log("  [WARNING] lua data is nil at UserExtendRef:fromLua")
        return 
    }
    console.log("@@@@run userextend init from lua")
    for (let k in src) {
        let v = src[k]
        if ($null(v)) continue
        if (k === "fruitTreeLevel") {
            self.setFruitTreeLevel(v)
        } else if (k === "starReward") {
            self.setStarReward(v)
        } else if (k === "newUserReward") {
            self.setNewUserReward(v)
        }else if (k === "shortcutReward") {
            self.setShortcutReward(v)
        }else if (k === "shortcutEnterReward") {
            self.setShortcutEnterReward(v)
        }else if (k === "isFirstPay") {
            self.setIsFristPay(v)
        } else if (k === "energyPlusEffectTime") {
            self.setEnergyPlusEffectTime(v)
        } else if (k === "notConsumeEnergyBuff") {
            self.setNotConsumeEnergyBuff(v)
        } else if (k === "inviteFriendCount") {
            self.inviteFriendCount = v
        } else if (k === "inviter") {
            self.inviter = tonumber(v || 0)
        } else if (k === "prePropNoLimitTime") {
            self.setPrePropNoLimitTime(tonumber(v) || 0)
        } else if (k === "lastPayTime") {
            self.lastPayTime = tonumber(v || 0)
        } else if (k === "consumeSum") {
            self.consumeSum = tonumber(v || 0)
        } else if (k === "hasFetchLeadRewards") {
            self.hasFetchLeadRewards = v
        } else if (k === "lastShowSubscribeWhatsNewTs") {
            self.lastShowSubscribeWhatsNewTs = tonumber(v || 0)
        } else {
            if (type(v) !== "function") {
                if (k == "ipRegionLimit"){
                    console.log("@@@@init from lua ip region limit:"+JSON.stringify(v))
                }
                self[k] = v
            }
            if (debugDataRef) {
                cc.log(k, v)
            }
        }
    }
    if (src.notConsumeEnergyBuff == null) {
        self.setNotConsumeEnergyBuff(0)
    }
    if (src.energyPlusEffectTime == null) {
        self.setEnergyPlusEffectTime(0)
    }
    if (src.newUserReward == null) {
        self.setNewUserReward(0)
    }
    if (src.inviteFriendCount == null) {
        self.inviteFriendCount = 0
    }
    if (src.identifyNum == null) {
        self.identifyNum = null
    }
    if (type(src.prePropNoLimitTime) !== "number") {
        self.setPrePropNoLimitTime(0)
    }
}
UserExtendRef.prototype.encode = function () {
    var self = this
    var dst = table()
    self.fruitTreeLevel = self.getFruitTreeLevel()
    self.starReward = self.getStarReward()
    self.newUserReward = self.getNewUserReward()
    self.energyPlusEffectTime = self.getEnergyPlusEffectTime()
    self.notConsumeEnergyBuff = self.getNotConsumeEnergyBuff()
    self.prePropNoLimitTime = self.getPrePropNoLimitTime()
    for (let k in self) {
        let v = self[k]
        if ($null(v)) continue
        if (k != "class" && v != null && type(v) != "function") {
            dst[k] = v
        }
    }
    return dst
}
//-------------------------------------------------------------------------------------------------

// PropRef ---------------------------------------------------------
PropRef = xClass("PropRef", DataRef)
PropRef.prototype.ctor = function () {
    var self = this
    self.itemId = 0
    self.num = 0
}
PropRef.prototype.dispose = function () { }
PropRef.prototype.fromLua = function (data) {
    var self = this
    self.itemId = data.itemId || 0
    self.num = tonumber(value) || 0
}
PropRef.prototype.encode = function () {
    var self = this
    return table([1, "itemId", self.itemId], [1, "num", self.num])
}
PropRef.prototype.getNum = function () {
    var self = this
    return self.num
}
PropRef.prototype.setNum = function (value) {
    var self = this
    self.num = tonumber(value) || 0
}
PropRefEncypt = xClass("PropRefEncypt", DataRef)
PropRefEncypt.prototype.ctor = function () {
    var self = this
    self.itemId = 0
    self.setNum(0)
}
PropRefEncypt.prototype.dispose = function () {
    var self = this
    he.HeMemDataHolder.deleteByKey("PropRefEncypt.num." + self.itemId)
}
PropRefEncypt.prototype.fromLua = function (src) {
    var self = this
    self.itemId = tonumber(src.itemId) || 0
    self.setNum(tonumber(src.num) || 0)
}
PropRefEncypt.prototype.encode = function () {
    var self = this
    return table([1, "itemId", self.itemId], [1, "num", self.getNum()])
}
PropRefEncypt.prototype.getNum = function () {
    var self = this
    // WARN: maybe multi result
    return decrypt_integer("PropRefEncypt.num." + self.itemId)
}
PropRefEncypt.prototype.setNum = function (value) {
    var self = this
    encrypt_integer("PropRefEncypt.num." + self.itemId, tonumber(value) || 0)
}
//----------------------
// 限时道具
//----------------------
TimePropRef = xClass("TimePropRef", DataRef)
TimePropRef.prototype.ctor = function () {
    var __VA_ARG = $slice(arguments, 0)
    var self = this
    self.itemId = 0
    self.num = 0
    self.expireTime = 0
}
TimePropRef.prototype.fromLua = function (src) {
    var self = this
    self.itemId = src.itemId
    self.num = src.num || 1
    self.expireTime = tonumber(src.expireTime)
}
TimePropRef.prototype.encode = function () {
    var self = this
    var dst = table()
    dst.itemId = self.itemId
    dst.num = self.num
    dst.expireTime = self.expireTime
    return dst
}
// RankRef ---------------------------------------------------------
RankRef = xClass("RankRef", DataRef)
RankRef.prototype.ctor = function () {
    var self = this
    self.uid = "0"
    self.levelId = 1
    self.score = 0
    self.rank = 0
}
RankRef.prototype.fromLua = function (data) {
    var self = this
    self.uid = tostring(tonumber(data.uid) || 0)
    self.levelId = tonumber(data.levelId) || 1
    self.score = tonumber(data.score) || 0
    self.rank = tonumber(data.rank) || 0
    return self
}
RankRef.prototype.encode = function () {
    var self = this
    var data = table()
    data.uid = self.uid
    data.levelId = self.levelId
    data.score = self.score
    data.rank = self.rank
}
// ScoreRef ---------------------------------------------------------
ScoreRef = xClass("ScoreRef", DataRef)
ScoreRef.prototype.ctor = function () {
    var self = this
    self.uid = 0
    self.levelId = 1
    self.score = 0
    self.star = 0
    self.updateTime = 0
}
ScoreRef.prototype.fromLua = function (data) {
    var self = this

    if (type(data) !== "table") {
        if ((data.score <= 0 && data.star <= 0) ||
            (data[1] <= 0 && data[2] <= 0)) {
            return null
        }
    }

    if (data.score != undefined) {
        // 旧版接口，传的对象
        self.uid = tonumber(data.uid) || 0
        self.levelId = tonumber(data.levelId) || 1
        self.score = tonumber(data.score) || 0
        self.star = tonumber(data.star) || 0
        self.updateTime = tonumber(data.updateTime) || 0

    } else {
        // 新版接口，传的数据
        self.levelId = tonumber(data[1]) || 1
        self.score = tonumber(data[2]) || 0
        self.star = tonumber(data[3]) || 0
        self.updateTime = tonumber(data[4]) || 0
        self.uid = tonumber(data[5]) || 0
    }
    return self
}
//----------------------------------------
//分支关卡信息
//---------------------------------------
BranchRef = xClass("BranchRef", DataRef)
BranchRef.prototype.ctor = function () {
    var __VA_ARG = $slice(arguments, 0)
    var self = this
    // body
    self.branchId = 0
    self.sucLevel = 0
    self.failLevel = 0
    self.started = false
}
// UnLockFriendInfoRef ---------------------------------------------------------
UnLockFriendInfoRef = xClass("UnLockFriendInfoRef", DataRef)
UnLockFriendInfoRef.prototype.ctor = function () {
    var self = this
    self.id = 0
    self.friendUids = table()
}
// DailyDataRef ---------------------------------------------------------
DailyDataRef = xClass("DailyDataRef", DataRef)
DailyDataRef.prototype.ctor = function () {
    var self = this
    self.activeSendIds = table()
    self.passiveSendIds = table()
    self.wantIds = table()
    self.receiveGiftCount = 0
    self.buyedGoodsInfo = table()
    self.todayShareCount = 0
    self.douyinShareVideoCnt = 0
}
DailyDataRef.prototype.resetAll = function () {
    var self = this
    self.activeSendIds = table()
    self.passiveSendIds = table()
    self.wantIds = table()
    self.receiveGiftCount = 0
    self.buyedGoodsInfo = table()
    self.todayShareCount = 0
    self.douyinShareVideoCnt = 0
}
DailyDataRef.prototype.fromLua = function (data) {
    var self = this
    if(!data){
        return
    }
    for (var i = 1, v = (data.activeSendIds || table())[1]; v; i++, v = (data.activeSendIds || table())[i]) {
        if(!v){
            continue
        }
        table.insert(self.activeSendIds, v)
    }
    for (var i = 1, v = (data.passiveSendIds || table())[1]; v; i++, v = (data.passiveSendIds || table())[i]) {
        if(!v){
            continue
        }
        table.insert(self.passiveSendIds, v)
    }
    for (var i = 1, v = (data.wantIds || table())[1]; v; i++, v = (data.wantIds || table())[i]) {
        if(!v){
            continue
        }
        table.insert(self.wantIds, v)
    }
    self.receiveGiftCount = data.receiveGiftCount || 0
    for (var i = 1, v = (data.buyedGoodsInfo || table())[1]; v; i++, v = (data.buyedGoodsInfo || table())[i]) {
        if(!v){
            continue
        }
        self.buyedGoodsInfo[v.goodsId] = v.num
    }
    self.todayShareCount = data.todayShareCount || 0
    self.chestPassLevelShareRemainingCount = data.chestPassLevelShareRemainingCount || 0
    self.douyinShareVideoCnt = data.douyinShareVideoCnt
    return self
}
DailyDataRef.prototype.encode = function () {
    var self = this
    var dst = table()
    dst.activeSendIds = clone(self.activeSendIds)
    dst.passiveSendIds = clone(self.passiveSendIds)
    dst.wantIds = clone(self.wantIds)
    dst.receiveGiftCount = self.receiveGiftCount
    dst.buyedGoodsInfo = table()
    for (var k in self.buyedGoodsInfo) {
        var v = self.buyedGoodsInfo[k]
        table.insert(dst.buyedGoodsInfo, table([1, "goodsId", k], [1, "num", v]))
    }
    dst.douyinShareVideoCnt = self.douyinShareVideoCnt
    return dst
}
DailyDataRef.prototype.getCurrentShareReward = function () {
    let self = this
    let limit = MetaManager.getDailyShareCountLimit()
    if (self.todayShareCount >= limit) {
        return table()
    }
    let meta = MetaManager.getDailyShareRewardInfo()
    let reward = $table(meta.startReward)
    for (let key in reward) {
        let v = reward[key];
        v.num = Math.max(v.num - self.todayShareCount * meta.delta, 0)
    }
    return reward
}
DailyDataRef.prototype.getWxPassLevelShareRemainingCount = function () {
    var self = this
    return self.chestPassLevelShareRemainingCount
}
DailyDataRef.prototype.subWxPassLevelShareRemainingCount = function () {
    var self = this
    self.chestPassLevelShareRemainingCount -= 1
}
DailyDataRef.prototype.addShareCount = function () {
    var self = this
    self.todayShareCount  = self.todayShareCount + 1
}
DailyDataRef.prototype.getBuyedGoodsNumber = function (goodsId) {
    var self = this
    return self.buyedGoodsInfo[goodsId] || 0
}
DailyDataRef.prototype.addBuyedGoods = function (goodsId, num) {
    var self = this
    self.buyedGoodsInfo[goodsId] = (self.buyedGoodsInfo[goodsId] || 0) + num
}
DailyDataRef.prototype.addWantIds = function (ids) {
    var self = this
    for (var k = 1, v = ids[1]; v; k++, v = ids[k]) {
        table.insert(self.wantIds, v)
    }
}
DailyDataRef.prototype.getWantIds = function () {
    var __VA_ARG = $slice(arguments, 0)
    var self = this
    return self.wantIds
}
DailyDataRef.prototype.addActiveSendId = function (id) {
    var self = this
    table.insert(self.activeSendIds, id)
}
DailyDataRef.prototype.getActiveSendIds = function () {
    var __VA_ARG = $slice(arguments, 0)
    var self = this
    return self.activeSendIds
}
DailyDataRef.prototype.addPassiveSendId = function (id) {
    var self = this
    table.insert(self.passiveSendIds, id)
}
DailyDataRef.prototype.getPassiveSendIds = function () {
    var __VA_ARG = $slice(arguments, 0)
    var self = this
    return self.passiveSendIds
}
DailyDataRef.prototype.getSendGiftCount = function () {
    var __VA_ARG = $slice(arguments, 0)
    var self = this
    return $len(self.activeSendIds) + $len(self.passiveSendIds)
}
DailyDataRef.prototype.getReceiveGiftCount = function () {
    var __VA_ARG = $slice(arguments, 0)
    var self = this
    return self.receiveGiftCount
}
DailyDataRef.prototype.incReceiveGiftCount = function () {
    var __VA_ARG = $slice(arguments, 0)
    var self = this
    self.receiveGiftCount = self.receiveGiftCount + 1
}
DailyDataRef.prototype.decReceiveGiftCount = function () {
    var __VA_ARG = $slice(arguments, 0)
    var self = this
    self.receiveGiftCount = self.receiveGiftCount - 1
}
//-------------------------------------------------
//------------ LeaveArea
//-------------------------------------------------
he_log_warning("used in code ?")
assert(!global.LeaveArea)
LeaveArea = xClass("LeaveArea")
LeaveArea.prototype.init = function (levelAreaId) {
    var __VA_ARG = $slice(arguments, 1)
    var self = this
    assert(type(levelAreaId) === "number")
    assert($len(table([2, __VA_ARG])) === 0)
    self.levelAreaId = levelAreaId
}
LeaveArea.create = function (levelAreaId) {
    var __VA_ARG = $slice(arguments, 1)
    var self = this
    assert($len(table([2, __VA_ARG])) === 0)
    var newLeaveArea = LeaveArea.new()
    newLeaveArea.init(levelAreaId)
    return newLeaveArea
}
//-------------------------------------------------
//------------ UnlockFriendInfo
//-------------------------------------------------
UnlockFriendInfo = xClass("UnlockFriendInfo", DataRef)
UnLockFriendInfoRef.prototype.ctor = function () {
    var __VA_ARG = $slice(arguments, 0)
    var self = this
    assert($len(table([2, __VA_ARG])) === 0)
    self.id = 0
    self.friendUids = table()
}
// LevelDataInfo ---------------------------------------------------------
var kMaxComboStoreTime = 24 * 60 * 60 * 1000
LevelDataInfo = xClass("LevelDataInfo", DataRef)
LevelDataInfo.prototype.ctor = function () {
    var self = this
    self.maxConbo = 0
    self.comboStartTime = 0
    self.levels = table()
}
LevelDataInfo.prototype.getLevelInfo = function (levelId) {
    var self = this
    var key = tostring(levelId)
    var level = self.levels[key]
    if (level == null) {
        level = table(
            [1, "playTimes", 0],
            [1, "win", 0],
            [1, "failTimes", 0],
            [1, "lastUpdateTime", os.time()],
            [1, "createTime", os.time()]
        )
        self.levels[key] = level
    }
    return level
}
LevelDataInfo.prototype.onLevelWin = function (levelId, score) {
    var self = this
    var now = os.time()
    var level = self.getLevelInfo(levelId)
    var winBefore = level.win
    if (self.maxConbo > 15) {
        self.maxConbo = 0
    }
    var comboStartTime = self.comboStartTime
    if (now - comboStartTime > kMaxComboStoreTime) {
        self.maxConbo = 0
        self.comboStartTime = 0
    }
    if (winBefore === 0) {
        if (self.maxConbo === 0) {
            self.comboStartTime = now
        }
        self.maxConbo = self.maxConbo + 1
    }
    level.win = 1
    level.playTimes = level.playTimes + 1
    level.lastUpdateTime = now
}
LevelDataInfo.prototype.onLevelFail = function (levelId, score) {
    var self = this
    self.maxConbo = 0
    self.comboStartTime = 0
    var level = self.getLevelInfo(levelId)
    level.lastUpdateTime = os.time()
    level.playTimes = level.playTimes + 1
    level.failTimes = level.failTimes + 1
}
// HttpDataInfo ---------------------------------------------------------
HttpDataInfo = xClass("HttpDataInfo", DataRef)
HttpDataInfo.prototype.ctor = function () {
    var self = this
    self.list = table()
}
function updateHttpDataID(data) {
    if (data && data.endpoint && !data.id) {
        data.id = uuid.getUUID()
    }
}
HttpDataInfo.prototype.add = function (endpoint, body) {
    var self = this
    var data = table([1, "endpoint", endpoint], [1, "body", body])
    self.list = self.list || table()
    table.insert(self.list, data)
    updateHttpDataID(data)
}
HttpDataInfo.prototype.fromLua = function (src) {
    var self = this
    if (!src) {
        return 
    }
    self.list = src
    for (var i = 1, v = self.list[1]; v; i++, v = self.list[i]) {
        updateHttpDataID(v)
    }
}
HttpDataInfo.prototype.encode = function () {
    var self = this
    return self.list
}
HttpDataInfo.prototype.decode = function (src) {
    var self = this
    self.fromLua(src)
}
DigJewelCount = xClass("DigJewelCount", DataRef)
DigJewelCount.prototype.ctor = function () {
    var self = this
    self.setValue(0)
}
DigJewelCount.prototype.setValue = function (value) {
    var self = this
    var key = "DigJewelCount.digJewelCount" + tostring(self)
    self.digJewelCount = value
    encrypt_integer(key, value)
}
DigJewelCount.prototype.getValue = function () {
    var self = this
    var key = "DigJewelCount.digJewelCount" + tostring(self)
    // WARN: maybe multi result
    return decrypt_integer(key)
}
UpdateInfoRef = xClass("UpdateInfoRef", DataRef)
UpdateInfoRef.prototype.ctor = function () {
    var self = this
    self.reset()
}
UpdateInfoRef.prototype.fromLua = function (data) {
    var self = this
    if (!data) {
        self.reset()
        return self
    }
    self.type = tonumber(data.type) || 0
    self.tips = tostring(data.tips)
    self.version = tostring(data.version)
    self.updateUrl = data.updateUrl || ""
    self.md5 = tostring(data.md5)
    self.rewards = data.rewards
    self.level = tonumber(data.level) || 0
    self.pop = tonumber(data.pop) || 0
    self.size = tonumber(data.size) || 0
    self.imageUrl = data.imageUrl || ""
    self.imageUrlV2 = data.imageUrlV2 || ""
    self.userData = data.userData || ""
    return self
}
UpdateInfoRef.prototype.reset = function () {
    var self = this
    self.type = 0
    self.tips = ""
    self.version = ""
    self.updateUrl = ""
    self.md5 = "nil"
    self.rewards = table()
    self.level = 0
    self.pop = 0
    self.size = 0
    self.imageUrl = ""
    self.imageUrlV2 = ""
    self.userData = ""
}
UpdateInfoRef.prototype.encode = function () {
    var self = this
    var data = table()
    data.type = self.type
    data.tips = self.tips
    data.version = self.version
    data.updateUrl = self.updateUrl
    data.md5 = self.md5
    data.rewards = table.serialize(self.rewards)
    data.level = self.level
    data.size = tonumber(self.size) || 0
    data.imageUrl = self.imageUrl
    data.imageUrlV2 = self.imageUrlV2
    data.userData = self.userData || ""
    return data
}
UserRewardRefConst = table(
    [1, "kNone", 0],
    [1, "kBetaTest", 1],
    [1, "kIMessageReward1", 1],
    [1, "kIMessageReward2", 2],
    [1, "kIMessageReward3", 3],
    [1, "kBossUpdateReward", 4]
)
UserRewardRef = xClass("UserRewardRef", DataRef)
UserRewardRef.prototype.ctor = function () {
    var self = this
    self.rewardFlag = 0
}
UserRewardRef.prototype.fromLua = function (data) {
    var self = this
    self.rewardFlag = data.rewardFlag || 0
    return self
}
UserRewardRef.prototype.encode = function () {
    var self = this
    return table([1, "rewardFlag", self.rewardFlag])
}
UnlockInfoRef = xClass("UnlockInfoRef", DataRef)
UnlockInfoRef.prototype.ctor = function () {
    var self = this
    self.endTime = 0
    self.friendUids = table()
}
UnlockInfoRef.prototype.fromLua = function (data) {
    var self = this
    self.endTime = tonumber(data.endTime) || 0
    self.friendUids = clone(data.friendUids) || table()
    return self
}
UnlockInfoRef.prototype.encode = function () {
    var self = this
    return table([1, "endTime", self.endTime], [1, "friendUids", clone(self.friendUids)])
}
UnlockInfoRef.prototype.getEndTime = function () {
    var self = this
    return self.endTime
}
UnlockInfoRef.prototype.setEndTime = function (endTime) {
    var self = this
    self.endTime = endTime
}
UnlockInfoRef.prototype.getFriendUids = function () {
    var self = this
    // WARN: maybe multi result
    return clone(self.friendUids)
}
UnlockInfoRef.prototype.reset = function () {
    var self = this
    self.endTime = 0
    self.friendUids = table()
}
//-本地各种信息的每日缓存
LocalDailyDataRef = xClass("LocalDailyDataRef", DataRef)
LocalDailyDataRef.prototype.ctor = function () {
    var __VA_ARG = $slice(arguments, 0)
    var self = this
    self.day = 0
    self.sendNearbyRequestCount = 0
    self.sendLinkFriendRequestCount = 0
    self.markPanelShow = false
    self.piggyBankPanelLoginShow = false //每日登陆首次显示
    self.piggyBankPanelFullShowCount = 0 //每日存钱罐满了之后弹出次数


    var data = UserLocalSettings.getSetting("local.dailydata");
    if (data) {
        data = JSON.parse(data)
        self.day = data.day;
        self.markPanelShow = data.markPanelShow;
        self.piggyBankPanelLoginShow = data.piggyBankPanelLoginShow;
        self.piggyBankPanelFullShowCount = data.piggyBankPanelFullShowCount || 0;
    }
}
LocalDailyDataRef.prototype.resetAll = function () {
    var __VA_ARG = $slice(arguments, 0)
    var self = this
    self.sendNearbyRequestCount = 0
    self.sendLinkFriendRequestCount = 0
    self.markPanelShow = false
    self.piggyBankPanelLoginShow = false
    self.piggyBankPanelFullShowCount = 0 

}
LocalDailyDataRef.prototype.fromLua = function (data) {
    var self = this
    if (!data) {
        return 
    }
    if (data.day) {
        self.day = data.day
    }
    if (data.sendNearbyRequestCount) {
        self.sendNearbyRequestCount = data.sendNearbyRequestCount
    }
    if (data.markPanelShow) {
        self.markPanelShow = data.markPanelShow
    }
    if (data.sendLinkFriendRequestCount) {
        self.sendLinkFriendRequestCount = data.sendLinkFriendRequestCount
    }

    if (data.piggyBankPanelLoginShow) {
        self.piggyBankPanelLoginShow = data.piggyBankPanelLoginShow
    }
    if (data.piggyBankPanelFullShowCount) {
        self.piggyBankPanelFullShowCount = data.piggyBankPanelFullShowCount
    }

}
LocalDailyDataRef.prototype.checkDateChange = function () {
    var __VA_ARG = $slice(arguments, 0)
    var self = this

    var day = Localhost.timeInDay()
    if (self.day !== day) {
        self.day = day
        self.resetAll()
    }
}
LocalDailyDataRef.prototype.encode = function () {
    var __VA_ARG = $slice(arguments, 0)
    var self = this
    var dst = table()
    dst.day = self.day
    dst.sendNearbyRequestCount = self.sendNearbyRequestCount
    dst.markPanelShow = self.markPanelShow
    dst.sendLinkFriendRequestCount = self.sendLinkFriendRequestCount

    dst.piggyBankPanelLoginShow = self.piggyBankPanelLoginShow
    dst.piggyBankPanelFullShowCount = self.piggyBankPanelFullShowCount
    return dst
}
LocalDailyDataRef.prototype.addNearbyRequestCount = function () {
    var __VA_ARG = $slice(arguments, 0)
    var self = this
    self.sendNearbyRequestCount = self.sendNearbyRequestCount + 1
}
LocalDailyDataRef.prototype.addLinkFriendRequestCount = function (count) {
    var self = this
    self.sendLinkFriendRequestCount = self.sendLinkFriendRequestCount + count
}
LocalDailyDataRef.prototype.isLinkFriendRequestAvailable = function () {
    var __VA_ARG = $slice(arguments, 0)
    var self = this
    return self.sendLinkFriendRequestCount < 32
}
LocalDailyDataRef.prototype.isNearbyRequestAvailable = function () {
    var __VA_ARG = $slice(arguments, 0)
    var self = this
    return self.sendNearbyRequestCount < 20
}
LocalDailyDataRef.prototype.getBetaRewardPanelShow = function () { return true }
LocalDailyDataRef.prototype.setBetaRewardPanelShow = function (show) {}
LocalDailyDataRef.prototype.setMarkPanelShow = function (show) {
    var self = this
    self.markPanelShow = show
    Localhost.getInstance().flushCurrentUserData()
}
LocalDailyDataRef.prototype.setPiggyBankPanelLoginShow = function (show) {
    var self = this
    self.piggyBankPanelLoginShow = show
    Localhost.getInstance().flushCurrentUserData()
}
LocalDailyDataRef.prototype.addPiggyBankPanelFullShowCount = function () {
    var self = this
    self.piggyBankPanelFullShowCount++;
    Localhost.getInstance().flushCurrentUserData()
}



DailySendGiftRef = xClass("DailySendGiftRef", DataRef)
DailySendGiftRef.prototype.ctor = function () {
    var self = this
    self.infos = table()
}
DailySendGiftRef.prototype.fromLua = function (data) {
    let self = this
    if (data == null) {
        return self
    }
    var day = Localhost.timeInDay()
    data.infos = data.infos || table()
    for (var k = 1, v = data.infos[1]; v; k++, v = data.infos[k]) {
        if (v.day >= day - 1) {
            self.infos[v.day] = v
        }
    }
    return self
}
DailySendGiftRef.prototype.addSendIds = function (day, ids) {
    var self = this
    if (self.infos[day]) {
        for (var k = 1, v = ids[1]; v; k++, v = ids[k]) {
            table.insert(self.infos[day].ids, v)
        }
    }
}
DailySendGiftRef.prototype.getInfo = function (day) {
    var self = this
    return self.infos[day]
}
DailySendGiftRef.prototype.setSendFirst = function (day, uidList) {
    var self = this
    if (self.infos[day]) {
        //-today already set
        return 
    } else {
        self.infos[day] = table()
        self.infos[day].day = day
        self.infos[day].ids = table()
        for (var k = 1, v = uidList[1]; v; k++, v = uidList[k]) {
            table.insert(self.infos[day].ids, v)
        }
    }
}
DailySendGiftRef.prototype.encode = function () {
    let self = this
    let infos = table()
    for (let k in self.infos) {
        let v = self.infos[k]
        if ($null(v)) continue
        table.insert(infos, v)
    }
    return table([1, "infos", infos])
}
MarkRef = xClass("MarkRef", DataRef)
MarkRef.prototype.ctor = function () {
    var self = this
    self.uid = 0
    self.addNum = 0
    self.markNum = 0
    self.markTime = 0
    self.startTime = 0
    self.randomRewards = table()
    self.markList = table()
    self.isNewMark = false
    self.videoTimes = 0
}
MarkRef.prototype.fromLua = function (markInfo, isNewMark) {
    var self = this

    if (type(markInfo) !== "table") {
        return self
    }
    self.isNewMark = isNewMark
    if (self.isNewMark) {
        //  上次签到时已经是新版签到了
        self.uid = tonumber(markInfo.uid) || 0
        self.startTime = tonumber(markInfo.periodStartTime) || 0
        self.addNum = tonumber(markInfo.supplyTimes) || 0
        if (markInfo.markList) {
            self.markNum = $len(markInfo.markList) || 0
        }
        self.markTime = tonumber(markInfo.lastMarkTime) || 0
        self.videoTimes = tonumber(markInfo.videoTimes) || 0
        self.markList = table()
        let markItem = markInfo.markList || table()
        for (let k = 1; k <= 7; k++) {
            if (k <= $len(markItem)) {
                self.markList[k] = markItem[k]
            } else {
                self.markList[k] = 0
            }
        }
    } else {
        //  上次签到时还是老版签到
        self.uid = tonumber(markInfo.uid) || 0
        self.startTime = tonumber(markInfo.periodStartTime) || 0
        self.addNum = tonumber(markInfo.addNum) || 0
        self.markNum = tonumber(markInfo.markNum) || 0
        self.markTime = tonumber(markInfo.markTime) || 0
        self.randomRewards = table()
        let $st377 = markInfo.randomRewards || table()
        for (let k = 1, v = $st377[1]; v; k++, v = $st377[k]) {
            let reward = RewardRef.create()
            reward.fromLua(v)
            table.insert(self.randomRewards, reward)
        }
    }
    return self
}
MarkRef.prototype.getAddNum = function () {
    var self = this
    return self.addNum
}
MarkRef.prototype.setAddNum = function (value) {
    var self = this
    self.addNum = value
}
MarkRef.prototype.getMarkNum = function () {
    var self = this
    return self.markNum
}
MarkRef.prototype.setMarkNum = function (value) {
    var self = this
    self.markNum = value
}
MarkRef.prototype.getMarkTime = function () {
    var self = this
    return self.markTime
}
MarkRef.prototype.setMarkTime = function (value) {
    var self = this
    self.markTime = value
}
MarkRef.prototype.getStartTime = function () {
    var self = this
    return self.startTime
}
MarkRef.prototype.setStartTime = function (value) {
    var self = this
    self.startTime = value
}
MarkRef.prototype.getMarkList = function () {
    var self = this
    return self.markList || table()
}
MsgAmountRef = xClass("MsgAmountRef", DataRef)
MsgAmountRef.prototype.ctor = function () {
    var self = this
    self.msgCenterNum = 0
    self.giftMsgNum = 0
    self.sysMsgNum = 0
    self.sendGiftMsgNum = 0
    self.wantGiftMsgNum = 0
    self.islandMsgNum = 0  //微信平台特有
    self.challengeMsgNum = 0 //挑战
    self.sysMsgIdList = table()
}
MsgAmountRef.prototype.fromLua = function (data) {
    var self = this
    if (type(data) !== "table") {
        return self
    }
    self.msgCenterNum = tonumber(data.msgCenterNum) || 0
    self.giftMsgNum = tonumber(data.giftMsgNum) || 0
    self.sysMsgNum = tonumber(data.sysMsgNum) || 0
    self.sendGiftMsgNum = tonumber(data.sendGiftMsgNum) || 0
    self.wantGiftMsgNum = tonumber(data.wantGiftMsgNum) || 0
    self.islandMsgNum = tonumber(data.islandMsgNum) || 0
    self.challengeMsgNum = tonumber(data.challengeMsgNum) || 0
    for (var _ = 1, v = (data.sysMsgIdList || table())[1]; v; _++, v = (data.sysMsgIdList || table())[_]) {
        if (!table.indexOf(self.sysMsgIdList, v)) {
            table.insert(self.sysMsgIdList, v)
        }
    }
}
createPropertyMethod(MsgAmountRef, "msgCenterNum")
createPropertyMethod(MsgAmountRef, "giftMsgNum")
createPropertyMethod(MsgAmountRef, "sysMsgNum")
createPropertyMethod(MsgAmountRef, "sendGiftMsgNum")
createPropertyMethod(MsgAmountRef, "wantGiftMsgNum")
createPropertyMethod(MsgAmountRef, "islandMsgNum")
createPropertyMethod(MsgAmountRef, "challengeMsgNum")
MsgAmountRef.prototype.getTotalMsgNum = function () {
    var self = this
    return self.msgCenterNum + self.giftMsgNum + self.sysMsgNum + (self.islandMsgNum==null?0:self.islandMsgNum)
}
MsgAmountRef.prototype.getSysMsgIdList = function () {
    var self = this
    return self.sysMsgIdList
}
MsgAmountRef.prototype.encode = function () {
    var self = this
    return table(
        [1, "msgCenterNum", 0],
        [1, "giftMsgNum", 0],
        [1, "sysMsgNum", self.sysMsgNum]
    )
}
// PropRef ---------------------------------------------------------
GroupInfoRef = xClass("GroupInfoRef", DataRef)
GroupInfoRef.prototype.ctor = function () {
    var self = this
    self.friendUid = 0
    self.flag = 0
    self.reward = table()
}
GroupInfoRef.prototype.parseRewardFlag = function (flag, rewardCount) {
    var self = this
    var ret = table()
    flag = Math.min(flag, 2 ^ rewardCount - 1)
    var $var322 = rewardCount
    for (var i = $var322; i >= 1; i += -1) {
        var bit = 2 ^ (i - 1)
        if (flag >= bit) {
            ret[i] = 1
            flag = flag - bit
        } else {
            ret[i] = 0
        }
    }
    return ret
}
GroupInfoRef.prototype.fromLua = function (data) {
    var self = this
    self.friendUid = data.friendUid || 0
    self.flag = data.flag || 0
    var rewardMeta = MetaManager.getInstance().invite_reward || table()
    self.reward = self.parseRewardFlag(self.flag, $len(rewardMeta))
}
// AppConfigRef ---------------------------------------------------------
AppConfigRef = xClass("AppConfigRef", DataRef)
AppConfigRef.prototype.ctor = function () {
    let self = this
    self.levelRankInterval = 60
    self.levelRankBatch = 50
    self.pollLevelCount = 90
    self.levelRankRoundWait = 100
    self.shareType = 0
    self.shareRedirectType = 0
    self.weekMatchShareEnable = 1
    self.enterActPopNum = 1
    self.enterFuncPopNum = 2
    self.weekMatchBeginTimestamp = Localhost.timeInSec() + 315360000
    self.levelRankGapRequestTS = 60
}
AppConfigRef.prototype.fromLua = function (data) {
    let self = this
    data = data || table()
    self.levelRankInterval = tonumber(data.levelRankInterval) || 60
    self.levelRankBatch = tonumber(data.levelRankBatch) || 50
    self.levelRankRoundWait = tonumber(data.levelRankRoundWait) || 100
    self.pollLevelCount = tonumber(data.pollLevelCount) || 90
    self.levelRankGapRequestTS = tonumber(data.levelRankGapRequestTS) || 60
    self.weekMatchShareEnable = tonumber(data.weekMatchShareEnable) || 1
    self.shareType = tonumber(data.shareType) || 0
    self.shareRedirectType = tonumber(data.shareRedirectType) || 0
    self.weekMatchBeginTimestamp = tonumber(data.weekMatchBeginTimestamp) || (Localhost.timeInSec() + 315360000)
    self.enterActPopNum = tonumber(data.enterActPopNum) || 1
    self.enterFuncPopNum = tonumber(data.enterFuncPopNum) || 2
    return self
}
AppConfigRef.prototype.encode = function () {
    let self = this
    let data = table()
    data.levelRankInterval = self.levelRankInterval
    data.levelRankBatch = self.levelRankBatch
    data.levelRankRoundWait = self.levelRankRoundWait
    data.pollLevelCount = self.pollLevelCount
    data.levelRankGapRequestTS = self.levelRankGapRequestTS
    data.weekMatchShareEnable = self.weekMatchShareEnable
    data.shareType = self.shareType
    data.shareRedirectType = self.shareRedirectType
    data.weekMatchBeginTimestamp = self.weekMatchBeginTimestamp
    data.enterActPopNum = self.enterActPopNum
    data.enterFuncPopNum = self.enterFuncPopNum
    return data
}
AppConfigRef.prototype.isWeekGameShare4GetCountEnable = function () {
    return false
}
// AppPromInfoRef ---------------------------------------------------------
AppPromInfoRef = xClass("AppPromInfoRef", DataRef)
AppPromInfoRef.prototype.ctor = function () {
    let self = this
    self.recentPayAmount = 0
    self.appPromList = table()
    self.rewardHistory = table()
}
AppPromInfoRef.prototype.fromLua = function (data) {
    let self = this
    data = data || table()
    self.recentPayAmount = tonumber(data.recentPayAmount) || 0
    if (data.appPromList) {
        for (let _ in data.appPromList) {
            let info = data.appPromList[_]
            if ($null(info)) continue
            let appProm = AppPromRef.create()
            appProm.fromLua(info)
            table.insert(self.appPromList, appProm)
            if (info.rewardStatus === 1) {
                self.rewardHistory[info.id] = true
            } else {
                self.rewardHistory[info.id] = false
            }
        }
    }
    return self
}
AppPromInfoRef.prototype.encode = function () {
    let self = this
    let data = table()
    data.recentPayAmount = self.recentPayAmount
    data.appPromList = table()
    for (let i = 1, v = self.appPromList[1]; v; i++, v = self.appPromList[i]) {
        let info = v.encode()
        if (self.rewardHistory[v.id]) {
            info.rewardStatus = 1
        } else {
            info.rewardStatus = 0
        }
        table.insert(data.appPromList, info)
    }
    return data
}
// WmInfoRef ---------------------------------------------------------
WmInfoRef = xClass("WmInfoRef", DataRef)
WmInfoRef.prototype.ctor = function () {
    let self = this
    self.leftPlay = 0
    self.normalLevelCount = 0
    self.helpUids = table()
    self.duration = table()
    self.minLevel = 0
    self.buyCount = 0
    self.target = 0
    self.maxTarget = 0
    self.rewards = table()
    self.freePlay = 0
    self.topRanks = table()
    self.profiles = table()
    self.rankRewards = table()
    self.chimelongRewards = table()
    self.phoneNum = ""
    self.chimelongLucker = table()
    self.shared = false
    self.areaCode = CITYCODE_FAILED
}
WmInfoRef.prototype.fromLua = function (data) {
    let self = this
    data = data || table()
    self.leftPlay = tonumber(data.leftPlay) || 0
    self.normalLevelCount = tonumber(data.normalLevelCount) || 0
    self.helpUids = data.helpUids || table()
    self.duration = data.duration || table()
    self.minLevel = data.minLevel || 0
    self.buyCount = tonumber(data.buyCount) || 0
    self.target = tonumber(data.target) || 0
    self.maxTarget = tonumber(data.maxTarget) || 0
    self.rewards = data.rewards || table()
    self.freePlay = tonumber(data.freePlay) || 0
    self.topRanks = table()
    let $st352 = data.topRanks || table()
    for (let k = 1, v = $st352[1]; v; k++, v = $st352[k]) {
        let rank = WmRankRef.create()
        rank.fromLua(v)
        table.insert(self.topRanks, rank)
    }
    self.profiles = table()
    let $st355 = data.profiles || table()
    for (let k = 1, v = $st355[1]; v; k++, v = $st355[k]) {
        let profile = ProfileRef.create()
        profile.fromLua(v)
        table.insert(self.profiles, profile)
    }
    self.rankRewards = table()
    let $st358 = data.rankRewards || table()
    for (let k = 1, v = $st358[1]; v; k++, v = $st358[k]) {
        let rankReward = WmRankRewardRef.create()
        rankReward.fromLua(v)
        table.insert(self.rankRewards, rankReward)
    }
    self.areaCode = tonumber(data.areaCode) || CITYCODE_FAILED
    self.chimelongRewards = data.chimelongRewards || table()
    self.phoneNum = data.phoneNum
    self.chimelongLucker = data.chimelongLucker
    self.shared = data.shared
    return self
}
WmInfoRef.prototype.encode = function () {
    let self = this
    let data = table()
    data.leftPlay = self.leftPlay
    data.normalLevelCount = self.normalLevelCount
    data.helpUids = self.helpUids
    self.duration = self.duration
    self.minLevel = self.minLevel
    data.buyCount = self.buyCount
    data.target = self.target
    data.maxTarget = self.maxTarget
    data.rewards = self.rewards
    data.freePlay = self.freePlay
    data.topRanks = table()
    for (let k = 1, v = self.topRanks[1]; v; k++, v = self.topRanks[k]) {
        table.insert(data.topRanks, v.encode())
    }
    data.profiles = table()
    for (let k = 1, v = self.profiles[1]; v; k++, v = self.profiles[k]) {
        table.insert(data.profiles, v.encode())
    }
    data.rankRewards = table()
    for (let k = 1, v = self.rankRewards[1]; v; k++, v = self.rankRewards[k]) {
        table.insert(data.rankRewards, v.encode())
    }
    data.areaCode = self.areaCode
    return data
}
WmInfoRef.prototype.resetDailyData = function () {
    let self = this
    self.leftPlay = 0
    self.normalLevelCount = 0
    self.helpUids = table()
    self.duration = table()
    self.minLevel = 0
    self.buyCount = 0
    self.shared = false
}
WmInfoRef.prototype.resetAllData = function () {
    let self = this
    self.fromLua(table())
}
// RewardRef ---------------------------------------------------------
RewardRef = xClass("RewardRef", DataRef)
RewardRef.prototype.ctor = function () {
    let self = this
    self.itemId = 0
    self.num = 0
}
RewardRef.prototype.fromLua = function (data) {
    let self = this
    data = data || table()
    self.itemId = tonumber(data.itemId) || 0
    self.num = tonumber(data.num) || 0
    return self
}
RewardRef.prototype.encode = function () {
    let self = this
    let data = table()
    data.itemId = self.itemId
    data.num = self.num
    return data
}
// WmRankRewardRef ---------------------------------------------------------
WmRankRewardRef = xClass("WmRankRewardRef", DataRef)
WmRankRewardRef.prototype.ctor = function () {
    let self = this
    self.type = 0
    self.rank = 0
    self.rewards = table()
}
WmRankRewardRef.prototype.fromLua = function (data) {
    let self = this
    data = data || table()
    self.type = tonumber(data.type) || 0
    self.rank = tonumber(data.rank) || 0
    self.rewards = table()
    let $st377 = data.rewards || table()
    for (let k = 1, v = $st377[1]; v; k++, v = $st377[k]) {
        let reward = RewardRef.create()
        reward.fromLua(v)
        table.insert(self.rewards, reward)
    }
    return self
}
WmRankRewardRef.prototype.encode = function () {
    let self = this
    let data = table()
    data.type = self.type
    data.rank = self.rank
    data.rewards = table()
    for (let k = 1, v = self.rewards[1]; v; k++, v = self.rewards[k]) {
        table.insert(data.rewards, v.encode())
    }
    return data
}
// GenericUserRef ---------------------------------------------------------
GenericUserRef = xClass("GenericUserRef", DataRef)
GenericUserRef.prototype.ctor = function () {
    let self = this
    self.uid = 0
    self.coin = 0
    self.cash = 0
    self.yellowStar = 0
    self.orangeStar = 0
    self.blueStar = 0
    self.energy = 0
    self.updateTime = 0
    self.starUpdateTime = 0
    self.topLevelId = 0
    self.friendNum = 0
    self.passTopLevel = 0
    self.branchLevelCount = 0
    self.inviteCode = 0
    self.beLiked = 0
    self.haveLiked = true
    self.headFrameId = 0
    self.honor = 0
}
GenericUserRef.prototype.fromLua = function (data) {
    let self = this
    data = data || table()
    self.uid = data.uid || 0
    self.coin = data.coin || 0
    self.cash = data.cash || 0
    self.yellowStar = data.yellowStar || 0
    self.orangeStar = data.orangeStar || 0
    self.blueStar = data.blueStar || 0
    self.energy = data.energy || 0
    self.updateTime = data.updateTime || 0
    self.starUpdateTime = data.starUpdateTime || 0
    self.topLevelId = data.topLevelId || 0
    self.friendNum = data.friendNum || 0
    self.passTopLevel = data.passTopLevel || 0
    self.branchLevelCount = data.branchLevelCount || 0
    self.inviteCode = data.inviteCode || 0
    self.beLiked = data.beLiked || 0
    self.haveLiked = data.haveLiked
    self.headFrameId = data.headFrameId || 0
    self.honor = data.honor || 0
    return self
}
GenericUserRef.prototype.encode = function () {
    let self = this
    let data = table()
    data.uid = self.uid
    data.coin = self.coin
    data.cash = self.cash
    data.yellowStar = self.yellowStar
    data.orangeStar = self.orangeStar
    data.blueStar = self.blueStar
    data.energy = self.energy
    data.updateTime = self.updateTime
    data.starUpdateTime = self.starUpdateTime
    data.topLevelId = self.topLevelId
    data.friendNum = self.friendNum
    data.passTopLevel = self.passTopLevel
    data.branchLevelCount = self.branchLevelCount
    data.inviteCode = self.inviteCode
    data.beLiked = self.beLiked
    data.haveLiked = self.haveLiked
    data.headFrameId = self.headFrameId
    data.honor = self.honor
    return data
}
// WmRankRef ---------------------------------------------------------
WmRankRef = xClass("WmRankRef", DataRef)
WmRankRef.prototype.ctor = function () {
    let self = this
    self.uid = 0
    self.targetNum = 0
    self.areaCode = 0
    self.headFrameId = 0
}
WmRankRef.prototype.fromLua = function (data) {
    let self = this
    data = data || table()
    self.uid = data.uid || 0
    self.targetNum = data.targetNum || 0
    self.areaCode = data.areaCode || 0
    self.headFrameId = data.headFrameId || 0
    return self
}
WmRankRef.prototype.encode = function () {
    let self = this
    let data = table()
    data.uid = self.uid
    data.targetNum = self.targetNum
    data.areaCode = self.areaCode
    data.headFrameId = self.headFrameId
    return data
}
// WmHistoryRef ---------------------------------------------------------
WmHistoryRef = xClass("WmHistoryRef", DataRef)
WmHistoryRef.prototype.ctor = function () {
    let self = this
    self.time = 0
    self.type = 0
    self.rank = 0
    self.season = 0
    self.areaCode = 0
}
WmHistoryRef.prototype.fromLua = function (data) {
    let self = this
    data = data || table()
    self.time = data.time || 0
    self.type = data.type || 0
    self.rank = data.rank || 0
    self.season = data.season || 0
    self.areaCode = data.areaCode || 0
    return self
}
WmHistoryRef.prototype.encode = function () {
    let self = this
    let data = table()
    data.time = self.time
    data.type = self.type
    data.rank = self.rank
    data.season = self.season
    data.areaCode = self.areaCode
    return data
}
SettinsRef = xClass("SettinsRef", DataRef)
SettinsRef.prototype.ctor = function () {
    let self = this
    self.data = {}
}
SettinsRef.prototype.fromLua = function (data) {
    let self = this
    self.data = data || {}
    if (self.data.weekendLoginGiftBeginTimes) {
        let first = self.data.weekendLoginGiftBeginTimes.split(",")[0]
        let time = new Date(first)
        if (isNaN(time.getTime())) {
            self.data.weekendLoginGiftBeginTimes = Localhost.time()
        }else {
            self.data.weekendLoginGiftBeginTimes = time.getTime()
        }
    }
    if (self.data.weekendLoginGiftEndTimes) {
        let first = self.data.weekendLoginGiftEndTimes.split(",")[0]
        let time = new Date(first)
        if (isNaN(time.getTime())) {
            self.data.weekendLoginGiftEndTimes = Localhost.time()
        }else {
            self.data.weekendLoginGiftEndTimes = time.getTime()
        }
    }
    if (self.data.todayBreakIceGiftCD !== undefined) {
        self.data.todayBreakIceGiftCD = self.data.todayBreakIceGiftCD + Localhost.timeInSec()
    }else {
        self.data.todayBreakIceGiftCD = Localhost.timeInSec()
    }
    if (self.data.discountGiftCD !== undefined) {
        self.data.discountGiftCD = self.data.discountGiftCD + Localhost.timeInSec()
    }else {
        self.data.discountGiftCD = Localhost.timeInSec()
    }

    var mcEndtime = self.data.mcCd + Math.floor(new Date().getTime() / 1000)
    self.data.mcEndtime = mcEndtime
    return self
}
SettinsRef.prototype.encode = function () {
    let self = this
    return $table(self.data)
}

/*  PiggyBankDataRef  */
PiggyBankDataRef = xClass("PiggyBankDataRef", DataRef)
PiggyBankDataRef.prototype.ctor = function () {
    let self = this
    self.state = -1
    self.stage = 0
    self.buyTime = 0
    self.fullTime = 0
    self.blueStar = 0
    self.orangeStar = 0
    self.yellowStar = 0
    self.stageStartTime = 0
    self.stageNotBuyTimes = 0
    self.piggyVersion = 0
    self.stageBuyMax = 0
}
PiggyBankDataRef.prototype.fromLua = function (data) {
    let self = this
    data = data || table()
    self.state = tonumber(data.state) || -1
    self.stage = tonumber(data.stage) || 0
    self.buyTime = tonumber(data.buyTime) || 0
    self.fullTime = tonumber(data.fullTime) || 0
    self.blueStar = tonumber(data.blueStar) || 0
    self.orangeStar = tonumber(data.orangeStar) || 0
    self.yellowStar = tonumber(data.yellowStar) || 0
    self.stageStartTime = tonumber(data.stageStartTime) || 0
    self.stageNotBuyTimes = tonumber(data.stageNotBuyTimes) || 0
    self.piggyVersion = tonumber(data.piggyVersion) || 0
    self.stageBuyMax = tonumber(data.stageBuyMax) || 0
}
PiggyBankDataRef.prototype.encode = function () {
    let self = this
    let data = table()
    data.state = self.state
    data.stage = self.stage
    data.buyTime = self.buyTime
    data.fullTime = self.fullTime
    data.blueStar = self.blueStar
    data.orangeStar = self.orangeStar
    data.yellowStar = self.yellowStar
    data.stageStartTime = self.stageStartTime
    data.stageNotBuyTimes = self.stageNotBuyTimes
    data.piggyVersion = self.piggyVersion
    data.stageBuyMax = self.stageBuyMax
    return data
}
/*  PiggyBankDataRef  */